import { controls, grouped } from "../controls";
const account_pmjjbys = {
  label: "Account Pmjjbys",
  pageLabel: "Account Pmjjbys", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false }, open: { allow: false } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Account" }),
    ...controls.oc({ tab: "filter", c: "Account", placeHolder: "Account Code", name: "AccountPMJJBY-account-account_code", fastpath: "accounts" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AccountPMJJBY-account-account_display" }),
    ...controls.displayText({ tab: "filter", label: "Customer" }),
    ...controls.oc({ tab: "filter", c: "Customer", placeHolder: "Customer Code", name: "AccountPMJJBY-account-customer-customer_code", fastpath: "customers" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AccountPMJJBY-account-customer-customer_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Saving Account", star: false }),
    ...controls.oc({ tab: "general", c: "Account", placeHolder: "Saving Account", name: "account_code", fastpath: "accounts", isReadOnly: "edit", displayData: { account_display: "account_display", account_uid: "account_uid", gender: "gender", pan: "pan", aadhaar: "aadhaar", mothers_name: "mothers_name", customer_code: "customer_code", religion: "religion", caste: "caste", mobile: "mobile", dob: "dob", customer_type: "customer_type", int_rate: "int_rate", open_date: "open_date", balance: "balance", prin_int: "prin_int", interest: "interest", penal: "charges", min_balance: "min_balance", expiry_date: "expiry_date", maturity_amount: "maturity_amount", close_date: "close_date", kyc_update_date: "kyc_update_date", fd_amount: "fd_amount", interest_date: "last_int_date", premium_amount: "premium_amount" }, hidden: false }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "account_display" }),
    ...controls.displayText({ tab: "general", label: "Premium Amount" }),
    ...controls.floatOnly({ tab: "general", placeHolder: "", name: "premium_amount", maxlength: 18, isReadOnly: "edit", isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Account Pmjjbys",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Account Code", accessor: "AccountPMJJBY-account-account_code", },
      { Header: "Account", accessor: "AccountPMJJBY-account-account_display", },
      { Header: "Customer Code", accessor: "AccountPMJJBY-account-customer-customer_code", },
      { Header: "AADHAAR UID", accessor: "AccountPMJJBY-account-customer-aadhaar", },
      { Header: "PAN", accessor: "AccountPMJJBY-account-customer-pan", },
      { Header: "Premium Amount", accessor: "premium_amount", },
      { Header: "Join Date", accessor: "join_date", type: 'date' },
    ]
  }
};
export default account_pmjjbys;